import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { Device } from '@/models/device';
import { DeviceModelType } from '@/models/deviceBaseModel';
import { getAllDevicesByCustomerId } from '@/use-cases/devices';
import { uniqueId } from '@/utils/misc';
import { ValidationRules } from '@/utils/validation';
import useVuelidate from '@vuelidate/core';
import { computed, onMounted, reactive, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DevicesSelect',
  props: {
    customerId: null,
    value: null,
    disabled: { type: Boolean, default: false },
    includeAll: { type: Boolean, default: false },
    deviceType: null,
    validationRules: { default: () => ({}) }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: number) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { customerId: number, value?: number | null, disabled: boolean, includeAll: boolean, deviceType?: DeviceModelType, validationRules: ValidationRules };





const componentId = uniqueId();
const items = ref<Device[]>([]);
const isLoading = ref<boolean>(false);

const state = reactive({
  device: props.value,
});
const validations = {
  device: props.validationRules,
};
const v$ = useVuelidate(validations, state);
const { t } = useI18n();

onMounted(() => {
  getItems();
});

async function getItems() {
  isLoading.value = true;
  try {
    const devices = await getAllDevicesByCustomerId(props.customerId);
    switch (props.deviceType) {
      case DeviceModelType.Laser:
        items.value = devices.filter((x) => x.isCut());
        break;
      case DeviceModelType.Bending:
        items.value = devices.filter((x) => x.isBend());
        break;
      case DeviceModelType.Tubes:
        items.value = devices.filter((x) => x.isTube());
        break;
      default:
        items.value = devices;
        break;
    }
  } finally {
    isLoading.value = false;
  }
}

function onInput(deviceId: number) {
  state.device = deviceId;
  emit('input', deviceId);
}

const required = computed(() => 'required' in props.validationRules);

const validationMessage = computed(() => v$.value.device.$errors[0]?.$message);

return { __sfc: true,props, emit, componentId, items, isLoading, state, validations, v$, t, getItems, onInput, required, validationMessage }
}

})